import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { get, isEmpty } from 'lodash';
import Table from './Table';
import { Tooltip, TooltipData } from '../elements-tooltip/tooltip';
import { normalizedContractsShape } from '../app-bookings-request/forms/bookingUtil';

export default class PayoutDifferenceTable extends Component {
  constructor (props) {
    super(props);

    this.parentTooltipRef = element => {
      this.tooltipRef = element;
    };
  }

  render () {
    const {
      hostId,
      currency,
      pendingContracts = {},
      currentContracts = {},
      tableHeaders,
      displayAddOnsTotal = false
    } = this.props;

    const payoutDiff = get(pendingContracts, 'masterContract.calculations.update_difference.payout', 0);
    const currentMasterCalc = get(currentContracts, 'masterContract.calculations', {});
    const newMasterCalc = get(pendingContracts, 'masterContract.calculations', {});

    const newAmounts = {
      addOnsTotal: get(newMasterCalc, 'host_add_ons_summary.amount') || get(newMasterCalc, 'add_ons.amount', 0),
      hostAmounts: get(newMasterCalc, 'host', {}),
      items: get(pendingContracts, 'items', []),
      spaceRentalTotal: get(pendingContracts, `spaceRentalContract.amount[${hostId}]`, 0)
    };

    const currentAmounts = {
      addOnsTotal: get(currentMasterCalc, 'host_add_ons_summary.amount') || get(currentMasterCalc, 'add_ons.amount', 0),
      hostAmounts: get(currentMasterCalc, 'host', {}),
      items: get(currentContracts, 'items', []),
      spaceRentalTotal: get(currentContracts, `spaceRentalContract.amount[${hostId}]`, 0)
    };

    const displayOldAddOnsTotal = get(currentMasterCalc, 'host_add_ons_summary') ||
      (currentAmounts.addOnsTotal && isEmpty(get(currentMasterCalc, 'concierge_add_ons_summary')));

    return (
      <div ref={this.parentTooltipRef} className="PayoutTable payout-table margin-lg-bottom">
        <Table
          tableHeaders={tableHeaders}
          tableBody={
            <div>
              <div className="table-row flex space-between full-width" style={{ gap: '8px' }}>
                <div className="flex-basis-50">
                  <FormattedMessage
                    id="inbox_review_booking_update.payout_difference_table.space_rental"
                    defaultMessage="Space rental total"
                  />
                </div>
                <div className="flex end flex-basis-50" style={{ gap: '8px' }}>
                  <div className="text-right flex-basis-50 d-xs-none d-sm-block" data-testing-id="previous-space-rental-total">
                    <FormattedNumber value={currentAmounts.spaceRentalTotal} currency={currency} style={'currency'} />
                  </div>
                  <div className="text-right flex-basis-50" data-testing-id="new-space-rental-total">
                    <FormattedNumber value={newAmounts.spaceRentalTotal} currency={currency} style={'currency'} />
                  </div>
                </div>
              </div>

              {
                ((!!displayAddOnsTotal || !!displayOldAddOnsTotal) &&
                  (!isEmpty(newAmounts.items) || !isEmpty(currentAmounts.items))) &&
                  <div className="table-row flex space-between full-width" style={{ gap: '8px' }} data-testing-id="add-ons-row">
                    <div className="flex-basis-50">
                      <FormattedMessage
                        id="inbox_review_booking_update.payout_difference_table.addons"
                        defaultMessage="Add-ons total"
                      />
                    </div>
                    <div className="flex end flex-basis-50" style={{ gap: '8px' }}>
                      <div className="text-right flex-basis-50 d-xs-none d-sm-block" data-testing-id="previous-add-ons-total">
                        <FormattedNumber value={displayOldAddOnsTotal ? currentAmounts.addOnsTotal : 0} currency={currency} style={'currency'} />
                      </div>
                      <div className="text-right flex-basis-50" data-testing-id="new-add-ons-total">
                        <FormattedNumber value={displayAddOnsTotal ? newAmounts.addOnsTotal : 0} currency={currency} style={'currency'} />
                      </div>
                    </div>
                  </div>
              }

              <div className="table-row flex space-between full-width" style={{ gap: '8px' }}>
                <div className="flex-basis-50">
                  <span className="margin-md-right">
                    <FormattedMessage
                      id="inbox_review_booking_update.payout_difference_table.fee"
                      defaultMessage="Service Fee"
                    />
                  </span>
                  <Tooltip tooltip={TooltipData.SERVICE_FEE} />
                </div>
                <div className="flex end flex-basis-50" style={{ gap: '8px' }}>
                  <div className="text-right flex-basis-50 d-xs-none d-sm-block" data-testing-id="previous-service-fee">
                    <FormattedNumber value={-currentAmounts.hostAmounts.fee} currency={currency} style={'currency'} />
                  </div>
                  <div className="text-right flex-basis-50" data-testing-id="new-service-fee">
                    <FormattedNumber value={-newAmounts.hostAmounts.fee} currency={currency} style={'currency'} />
                  </div>
                </div>
              </div>

              <hr className="dotted margin-md-top margin-md-bottom" />

              <div className="table-row flex space-between full-width" style={{ gap: '8px' }}>
                <div className="heavy flex-basis-50">
                  <FormattedMessage
                    id="inbox_review_booking_update.payout_difference_table.total"
                    defaultMessage="Total"
                  />
                </div>
                <div className="flex end flex-basis-50" style={{ gap: '8px' }}>
                  <div className="text-right flex-basis-50 d-xs-none d-sm-block" data-testing-id="previous-total">
                    <FormattedNumber value={get(currentAmounts, 'hostAmounts.payout', 0)} currency={currency} style={'currency'} />
                  </div>
                  <div className="text-right flex-basis-50" data-testing-id="new-total">
                    <FormattedNumber value={get(newAmounts, 'hostAmounts.payout', 0)} currency={currency} style={'currency'} />
                  </div>
                </div>
              </div>

              <div className="flex space-between table-row heavy">
                <div>
                  <FormattedMessage
                    id="inbox_review_booking_update.payout_difference_table.payout_change"
                    defaultMessage="Payout Change"
                  />
                </div>

                <div data-testing-id="host-payout">
                  <FormattedNumber value={payoutDiff * -1} currency={currency} style={'currency'} />
                </div>
              </div>
            </div>
          }
        />
      </div>
    );
  }
}

PayoutDifferenceTable.propTypes = {
  currency: PropTypes.string,
  hostId: PropTypes.string,
  pendingContracts: normalizedContractsShape,
  currentContracts: normalizedContractsShape,
  tableHeaders: PropTypes.array
};
